const RepositoryType = {
    UNKNOWN: "unknown",
    GITHUB: "github.com",
    BITBUCKET: "bitbucket.org"
}

export default RepositoryType